module.exports = __webpack_public_path__ + "static/media/slack.a97dc13c.svg";